import * as contentful from "contentful";

export const ResourceTileClient = contentful.createClient({
  space: import.meta.env.VITE_SPACE_ID,
  accessToken: import.meta.env.VITE_ACCESS_TOKEN_RESOURCE_TILE,
});
